import React, { useState } from 'react';
import { Alert, Button, Card, Descriptions, Divider, Drawer, Image, Popconfirm, Space, Typography } from 'antd';
import { formatCurrency } from 'utils/number';

const { Text } = Typography;

const getLineImage = (line) => {
  const image = line?.variant?.image
    || line?.variant?.images?.[0]
    || line?.product?.thumbnail
    || line?.product?.image
    || line?.product?.images?.[0]
    || null;

  if (!image) return null;
  if (typeof image === 'string') return image;
  return image?.url || null;
};

const OrderDetailMobile = ({ viewModel }) => {
  const [showActionSheet, setShowActionSheet] = useState(false);

  const {
    data,
    customer,
    lineItems,
    id,
    navigate,
    setIsModalPaymentProofOpen,
    setShowOrderPayment,
    setShowOrderHistoryModal,
    setShowOrderNoteModal,
    cancelOrder,
    finishOrder,
    createInvoice,
    createPackingList,
    createShippingLabel,
    openQuickStatusEditor,
  } = viewModel;

  const shippingStatusTitle = data.shipping_status?.title || data.shipping_status_id || '-';
  const internalStatusId = data.internal_status?.id || data.internal_status_id || data.internal?.status?.id;
  const internalStatusTitle = data.internal_status?.title
    || data.internal?.status?.title
    || data.store_setting?.order_internal_status_map?.[internalStatusId]?.title
    || internalStatusId
    || '-';

  const customerName = customer?.full_name || '-';
  const customerPhone = customer?.phone || '-';
  const shippingAddress = data.shipping_address?.address || '-';
  const orderNote = data.note || '-';

  const totals = [
    { label: 'Tiền hàng', value: data.sub_amount },
    { label: 'Giảm giá', value: data.discount_amount },
    { label: 'Mã khuyến mãi', value: data.voucher_amount },
    { label: 'Xu', value: data.point_discount },
    { label: 'Phí ship', value: data.shipping_amount },
  ];

  return (
    <Space direction="vertical" size={12} style={{ width: '100%' }}>
      <Card bodyStyle={{ padding: 14 }}>
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          {data.status == 'canceled' && (
            <Alert
              message="Đơn hàng này đã bị huỷ"
              description={`Lý do huỷ: ${data.cancel?.reason || ''}`}
              type="error"
              closable
            />
          )}

          {data.status == 'finalized' && (
            <Alert
              message="Đơn hàng này đã hoàn tất"
              description={`Ghi chú: ${data.finalized?.note || ''}`}
              type="success"
              closable
            />
          )}

          <Descriptions column={1} size="small" labelStyle={{ minWidth: 92 }}>
            <Descriptions.Item label="Mã đơn hàng">{data.id}</Descriptions.Item>
            <Descriptions.Item label="Khách hàng">{customerName}</Descriptions.Item>
            <Descriptions.Item label="SĐT">{customerPhone}</Descriptions.Item>
            <Descriptions.Item label="Thanh toán">{data.payment_status?.title || '-'}</Descriptions.Item>
            <Descriptions.Item label="Vận chuyển">{shippingStatusTitle}</Descriptions.Item>
            <Descriptions.Item label="Nội bộ">{internalStatusTitle}</Descriptions.Item>
            <Descriptions.Item label="Địa chỉ">{shippingAddress}</Descriptions.Item>
            <Descriptions.Item label="Ghi chú">{orderNote}</Descriptions.Item>
          </Descriptions>

          {data.commission > 0 && (
            <Descriptions column={1} size="small" labelStyle={{ minWidth: 92 }}>
              <Descriptions.Item label="CTV">{data.collaborator?.full_name || data.ref_code || '-'}</Descriptions.Item>
              <Descriptions.Item label="SĐT CTV">{data.collaborator?.phone || '-'}</Descriptions.Item>
              <Descriptions.Item label="Hoa hồng">{formatCurrency(data.commission)}</Descriptions.Item>
            </Descriptions>
          )}

          <Space.Compact block>
            <Button
              type="primary"
              block
              onClick={() => {
                setShowOrderPayment(true);
              }}
            >
              Thanh toán
            </Button>
            <Button block onClick={() => setShowActionSheet(true)}>
              Chức năng
            </Button>
          </Space.Compact>

          <Drawer
            title="Chức năng"
            placement="bottom"
            open={showActionSheet}
            onClose={() => setShowActionSheet(false)}
            height="80vh"
          >
            <Space direction="vertical" size={8} style={{ width: '100%' }}>
              <Button
                type="primary"
                block
                onClick={() => {
                  navigate(`/order/edit/${id}`);
                  setShowActionSheet(false);
                }}
              >
                Sửa
              </Button>

              <Button
                block
                onClick={() => {
                  openQuickStatusEditor();
                  setShowActionSheet(false);
                }}
              >
                Cập nhật nhanh trạng thái
              </Button>

              <Divider style={{ margin: '8px 0' }} />

              {data.payment_proof?.image && (
                <Button
                  block
                  onClick={() => {
                    setIsModalPaymentProofOpen(true);
                    setShowActionSheet(false);
                  }}
                >
                  Thông tin thanh toán
                </Button>
              )}

              <Button
                block
                onClick={() => {
                  setShowOrderNoteModal(true);
                  setShowActionSheet(false);
                }}
              >
                Ghi chú
              </Button>

              <Button
                block
                onClick={() => {
                  setShowOrderHistoryModal(true);
                  setShowActionSheet(false);
                }}
              >
                Lịch sử
              </Button>


              <Divider style={{ margin: '8px 0' }} />
              <Button
                type="primary"
                block
                onClick={() => {
                  createInvoice();
                  setShowActionSheet(false);
                }}
              >
                In Hoá Đơn
              </Button>

              <Button
                type="primary"
                block
                onClick={() => {
                  createPackingList();
                  setShowActionSheet(false);
                }}
              >
                In Phiếu Đóng Gói
              </Button>

              <Button
                type="primary"
                block
                onClick={() => {
                  createShippingLabel();
                  setShowActionSheet(false);
                }}
              >
                In Tem Vận Chuyển
              </Button>

              <Popconfirm
                title="Hoàn tất"
                description="Bạn có chắc chắn muốn hoàn tất đơn hàng này?"
                onConfirm={() => {
                  setShowActionSheet(false);
                  finishOrder();
                }}
                okText="Đồng ý"
                cancelText="Huỷ"
              >
                <Button block>Hoàn tất</Button>
              </Popconfirm>

              <Popconfirm
                title="Huỷ đơn hàng"
                description="Bạn có chắc chắn muốn huỷ đơn hàng này?"
                onConfirm={() => {
                  setShowActionSheet(false);
                  cancelOrder();
                }}
                okText="Đồng ý"
                cancelText="Huỷ"
              >
                <Button danger block>Huỷ</Button>
              </Popconfirm>
            </Space>
          </Drawer>
        </Space>
      </Card>

      <Card bodyStyle={{ padding: 14 }}>
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          {totals.map((item) => (
            <div key={item.label} style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
              <Text type="secondary">{item.label}</Text>
              <Text>{formatCurrency(item.value)}</Text>
            </div>
          ))}
          <Divider style={{ margin: '6px 0' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
            <Text strong>Tổng tiền</Text>
            <Text strong>{formatCurrency(data.total_amount)}</Text>
          </div>
        </Space>
      </Card>

      <Card bodyStyle={{ padding: 14 }}>
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
          <Text strong>Sản phẩm</Text>
          {lineItems.map((line) => (
            <Card
              key={`${line.product?.id || ''}-${line.variant?.id || ''}-${line.id || ''}`}
              size="small"
              bodyStyle={{ padding: 10 }}
            >
              <Space direction="vertical" size={8} style={{ width: '100%' }}>
                <Space size={8} align="start" style={{ width: '100%' }}>
                  {getLineImage(line) && (
                    <Image
                      src={getLineImage(line)}
                      width={42}
                      height={42}
                      style={{ objectFit: 'cover', borderRadius: 6, flexShrink: 0 }}
                      fallback='data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiI+PHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSIjZjVmNWY1Ii8+PC9zdmc+'
                    />
                  )}
                  <Space direction="vertical" size={0} style={{ width: '100%' }}>
                    <Text style={{ lineHeight: 1.4 }}>
                      {line.product?.name || '-'}
                    </Text>
                    {line.variant?.variant_title && (
                      <Text type="secondary" style={{ lineHeight: 1.3 }}>
                        {line.variant.variant_title}
                      </Text>
                    )}
                  </Space>
                </Space>

                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                  <Text type="secondary">Số lượng</Text>
                  <Text>{line.quantity}</Text>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                  <Text type="secondary">Đơn giá</Text>
                  <Text>{formatCurrency(line.price)}</Text>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                  <Text strong>Thành tiền</Text>
                  <Text strong>{formatCurrency(line.amount)}</Text>
                </div>
              </Space>
            </Card>
          ))}
        </Space>
      </Card>
    </Space>
  );
};

export default OrderDetailMobile;
